const CONSENT_KEY = "nexus-consent-preferences";

export const clearConsentPreferences = () => {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.removeItem(CONSENT_KEY);
};
